<template>
  <dialog-add
    icon="inventory"
    :title="$t('create_event_asset')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-events-asset class="elevation-1" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/events/assets');
    },
  },
};
</script>
